import React from 'react'
import { Box, Tabs, TabsProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface YumTabsProps extends Omit<TabsProps, 'onChange'> {
  classes: any
  children: React.ReactNode
  onChange: (event: React.ChangeEvent<{}>, value: any) => void
}

const YumTabs = withStyles((theme: Theme) =>
  createStyles({
    root: {
      //minHeight: '32px',
      minHeight: '2rem',
      borderRadius: '8px',
      padding: '4px',
      //marginBottom: '16px',
      backgroundColor: '#E3E3E8',
      /*[theme.breakpoints.up('md')]: {
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
      },*/
    },
    flexContainer: {
      zIndex: 1,
      position: 'relative',
    },
    tabIndicator: {
      //height: '28px',
      height: '1.75rem',
      //minHeight: '20px',
      borderRadius: '8px',
      backgroundColor: 'white',
    },
  }),
)(({ children, classes, ...props }: YumTabsProps) => {
  return (
    <Tabs
      variant="fullWidth"
      scrollButtons="off"
      textColor="primary"
      indicatorColor="primary"
      classes={{
        root: classes.root,
        flexContainer: classes.flexContainer,
      }}
      TabIndicatorProps={{
        className: classes.tabIndicator,
      }}
      {...props}
    >
      {children}
    </Tabs>
  )
})

export default YumTabs
